import {InsightFilters, InsightInterval} from "types/OperatorInsights";
import {DateTime} from "luxon";

const inputFormat = 'yyyy-LL-dd'

const intervals: Array<InsightInterval> = ['day', 'week', 'month', 'quarter', 'year']

const today = DateTime.now().startOf('day')

const defaultFilters: InsightFilters = {
    interval: 'week',
    compare: 'month',
    since: today.minus({week: 2}),
    until: today.endOf('day'),
}

function comparisonIsValid(interval: InsightInterval | string, compare: InsightInterval | string) {
    const intervalRank = intervals.indexOf(interval as InsightInterval)
    const comparisonRank = intervals.indexOf(compare as InsightInterval)

    return comparisonRank >= intervalRank
}

function dateValue(date: DateTime | string) {
    if(typeof date === 'string'){
        date = DateTime.fromISO(date)
    }

    return date.toFormat(inputFormat)
}

function dateString(date: DateTime | string, interval: InsightInterval) {
    if(typeof date === 'string'){
        date = DateTime.fromISO(date)
    }

    const formats: Record<InsightInterval, string> = {
        day: 'd LLLL y',
        week: "'Week' W, y",
        month: "LLLL y",
        quarter: "'Q'q, y",
        year: "y",
    }

    return date.toFormat(formats[interval])
}

export {inputFormat, intervals, today, defaultFilters, comparisonIsValid, dateValue, dateString}